/**
 * PatientAdminHome — thin satellite-app wrapper around this agent's census
 * board (../components/patientAdmin/PatientAdminBoard.tsx). Owns only the
 * standalone-app page chrome: title, ReturnToMainAgent, MainAppNav. The board
 * itself is the same one the main app's Home detail pane mounts through this
 * app's face (PatientAdminBoardConnected), and the same one this app's Session
 * page mounts — one board, never duplicated (frontend/CLAUDE.md).
 *
 * There is deliberately no "open assistant" action here. It used to POST a
 * session and route to /sessions/{id} — which mounts this same board. The
 * nurse pressed the header's most prominent button, waited on the network, and
 * arrived at a screen differing only by a share icon and a missing "add
 * patient" button, having created a session record that held nothing. This
 * agent's face IS the board (the Care Planner / Compatibility pattern); until it
 * has something to say that the board cannot, advertising an assistant is
 * advertising a surface that does not exist. The session ROUTE stays — existing
 * and shared patient-admin sessions must still open.
 */

import { useTranslation } from 'react-i18next'
import { ReturnToMainAgent } from '@frontend/components/ReturnToMainAgent'
import { MainAppNav } from '@frontend/components/MainAppNav'
import { PatientAdminBoard } from '../components/patientAdmin/PatientAdminBoard'

function Header() {
  const { t } = useTranslation()
  return (
    <header className="flex items-center gap-2 border-b border-neutral-200 bg-white px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))]">
      <ReturnToMainAgent className="-ml-2" />
      <h1 className="min-w-0 flex-1 truncate font-display text-[19px] font-semibold tracking-tight text-neutral-900">
        {t('patientAdmin.homeTitle')}
      </h1>
      <MainAppNav />
    </header>
  )
}

export default function PatientAdminHome() {
  return (
    <div className="flex h-dvh flex-col bg-[var(--color-surface-canvas,#ffffff)]">
      <Header />

      <main className="min-h-0 flex-1">
        <PatientAdminBoard />
      </main>
    </div>
  )
}
